export default __webpack_public_path__ + "static/media/18_photo.daa96b71.jpeg";